import React, { useState, useEffect, useRef } from 'react'
import { InputDiv, Label, Input, SearchOptions, Option } from '../../styles/select-style'
import ApiService from '../../../services/ApiService'
import { HeatNumberType } from './types'
import { CertificateType } from '../../../pages/ClientPanel/Certificates/CreateCertificate'

const SelectHeatNumberInCertificate:React.FC<{ certificate: CertificateType, setCertificate:React.Dispatch<React.SetStateAction<CertificateType>>, itsOurs: boolean }> = ({certificate, setCertificate, itsOurs}) => {
  const [ items, setItems ] = useState<HeatNumberType[]>([])
  const [ inputItem, setInputItem ] = useState<string>('')
  const [ showOptions, setShowOptions ] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const optionsRef = useRef<HTMLUListElement>(null)
  const [ selectedIndex, setSelectedIndex ] = useState(0)
  
  useEffect(() => {
    setInputItem(certificate.heatNumber?.heatNumber || '')
  }, [certificate.heatNumber?.id])
  
  useEffect(() => {
    setSelectedIndex(0)
    const handle = setTimeout(() => {
      ApiService.certificates.getHeatNumbers({ query: inputItem })
        .then((response: any) => {
          if(response.data) setItems(response.data)
        })
        .catch((error: any) => {
          console.log(error)
        })
    }, 300)

    return () => clearTimeout(handle)
  }, [inputItem])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        optionsRef.current &&
        inputRef.current &&
        !optionsRef.current.contains(target) &&
        !inputRef.current.contains(target)
      ) {
        setShowOptions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputItem(e.target.value)
  }

  const handleSelectItem = (item: HeatNumberType) => {
    setInputItem(item.heatNumber)
    setShowOptions(false)
    setCertificate(prev => ({
      ...prev,
      heatNumber: item
    }))
  }
  
  const handleSetOptionByKey = (e:React.KeyboardEvent) => {
    if(e.key === 'ArrowDown' && selectedIndex < items.length - 1) setSelectedIndex(prev => prev + 1)
    if(e.key === 'ArrowUp' && selectedIndex > 0) setSelectedIndex(prev => prev - 1)
    if(e.key === 'Enter') handleSelectItem(items[selectedIndex])
    if(e.key === 'Tab') setShowOptions(false)
  }

  return(
    <InputDiv>
      <Label>Número da corrida</Label>
      <Input 
        ref={inputRef}
        type='text' 
        placeholder={itsOurs ? 'Selecione uma M.P.' : 'Selecione'}
        value={inputItem}
        onFocus={() => setShowOptions(true)}
        onChange={handleChangeInput}
        onKeyDown={(e) => handleSetOptionByKey(e)}
        disabled={itsOurs}
      />
      {showOptions && 
        <SearchOptions ref={optionsRef}>
          {items.map((hn, index) => 
            <Option 
              key={index}
              onClick={() => handleSelectItem(hn)}
              isSelected={index === selectedIndex}
            >
              {hn.heatNumber}
            </Option>
          )}
        </SearchOptions>
      }
    </InputDiv>
  )
}

export default SelectHeatNumberInCertificate

